<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="form-group">
                <form v-on:submit.prevent="$emit('passwordRecovery')">
                    <label :for="name+'-name'">Email</label>
                    <input v-validate="'required'"
                           :name="name+'-name'"
                           :id="name+'-name'"
                           type="text"
                           class="form-control"
                           v-model="email">
                </form>
            </div>
        </template>

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                Annuleren
            </button>
            <button type="button" class="btn btn-primary" :disabled="!email.length" @click="passwordRecovery" data-dismiss="modal">
                <i class="fal fa-save mr-2"></i> Send
            </button>

        </div>
    </modal>
</template>

<script>
    export default {
        props: ['index', 'title', 'name', 'value'],
        data() {
            return {
                email: '',
            };
        },
        
        methods: {
            passwordRecovery() {
                this.$emit('passwordRecovery', this.email);
            },
        },
        
    }
</script>